import NumeroProcessoService from '@/services/NumeroProcessoService'

export const buscarNumero = async (numeroProcesso) => {
  var numeroProcessoService = new NumeroProcessoService()
  return numeroProcessoService.buscarNumeroProcessoFiltro({
    filtro: numeroProcesso
  })
}

export const buscarNumeroProcessoReserva = async (numeroProcesso) => {
  return buscarNumero(numeroProcesso).then((resp) => {
    resp.reserva = true
    return resp
  })
}

export const buscarNumeroProcessoNovo = async () => {
  return {
    tipoProtocolo: 'DOCUMENTO_AVULSO'
  }
}

export const buscarNumeroProcessoEdicao = async (numeroProcesso) => {
  return buscarNumero(numeroProcesso)
}
